import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import CircularReferenceInfoModal from 'screens/CircularReferenceInfoModal';
import { PlaylistLinkPermissionModal, getChildPlaylistPermissionStatus } from 'screens/PlaylistLinkPermissionModal';
import PlaylistPickerModal from 'screens/PlaylistPickerModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AddPlaylistManager(_ref) {
  var playlist = _ref.playlist,
    disabledItems = _ref.disabledItems,
    onSubmit = _ref.onSubmit,
    _onClose = _ref.onClose,
    getFullData = _ref.getFullData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showOptionalModal = _useState2[0],
    setShowOptionalModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCircularReferenceModal = _useState4[0],
    setShowCircularReferenceModal = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    playlistsToAdd = _useState6[0],
    setPlaylistsToAdd = _useState6[1];
  var _getChildPlaylistPerm = getChildPlaylistPermissionStatus({
      playlistsToCheck: playlistsToAdd,
      audience: playlist.audience,
      teamIds: playlist.teamIds,
      currentPlaylistId: playlist.id
    }),
    restrictedPlaylists = _getChildPlaylistPerm.restrictedPlaylists,
    allowedPlaylists = _getChildPlaylistPerm.allowedPlaylists,
    hasRestrictedPlaylists = _getChildPlaylistPerm.hasRestrictedPlaylists,
    hasCircularPlaylists = _getChildPlaylistPerm.hasCircularPlaylists,
    circularReferencePlaylists = _getChildPlaylistPerm.circularReferencePlaylists;

  // This function, being passed down to the itemPicker modal,
  // is used to update the playlistsToAdd state
  // in response to the user's selections there
  var onBeforeChange = function onBeforeChange(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    setPlaylistsToAdd(function (prev) {
      if (toRemove.length > 0) {
        return prev.filter(function (playlist) {
          return playlist.id !== toRemove[0].id;
        });
      }
      return [].concat(_toConsumableArray(prev), [toAdd[0]]);
    });
  };
  var submitPlaylistsToAdd = function submitPlaylistsToAdd(_ref3) {
    var _ref3$optional = _ref3.optional,
      optional = _ref3$optional === void 0 ? true : _ref3$optional;
    var circularContent = (circularReferencePlaylists === null || circularReferencePlaylists === void 0 ? void 0 : circularReferencePlaylists.map(function (playlist) {
      return _objectSpread(_objectSpread({}, playlist), {}, {
        id: playlist.id,
        optional: true
      });
    })) || [];
    var restrictedContent = (restrictedPlaylists === null || restrictedPlaylists === void 0 ? void 0 : restrictedPlaylists.map(function (playlist) {
      return _objectSpread(_objectSpread({}, playlist), {}, {
        id: playlist.id,
        optional: optional
      });
    })) || [];
    var allowedContent = (allowedPlaylists === null || allowedPlaylists === void 0 ? void 0 : allowedPlaylists.map(function (playlist) {
      return _objectSpread(_objectSpread({}, playlist), {}, {
        id: playlist.id,
        optional: false
      });
    })) || [];
    var content = [].concat(_toConsumableArray(circularContent), _toConsumableArray(restrictedContent), _toConsumableArray(allowedContent));
    setShowOptionalModal(false);
    onSubmit(content);
    setPlaylistsToAdd([]);
  };
  var submitPlaylistPicker = function submitPlaylistPicker() {
    if (hasCircularPlaylists) {
      setShowCircularReferenceModal(true);
      return;
    }
    if (hasRestrictedPlaylists) {
      setShowOptionalModal(true);
      return;
    }
    submitPlaylistsToAdd({
      optional: false
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PlaylistPickerModal, {
      parentPlaylistId: playlist.id,
      disabledItems: disabledItems,
      filterItems: function filterItems(_ref4) {
        var id = _ref4.id;
        return id !== playlist.id;
      },
      onSubmit: submitPlaylistPicker,
      onClose: function onClose() {
        setPlaylistsToAdd([]);
        _onClose();
      },
      onBeforeChange: onBeforeChange,
      getFullData: getFullData
    }), showCircularReferenceModal && /*#__PURE__*/_jsx(CircularReferenceInfoModal, {
      circularPlaylists: (circularReferencePlaylists === null || circularReferencePlaylists === void 0 ? void 0 : circularReferencePlaylists.map(function (item) {
        return item.name;
      })) || [],
      onCloseModal: function onCloseModal() {
        setShowCircularReferenceModal(false);
      },
      onSubmit: function onSubmit() {
        setShowCircularReferenceModal(false);
        if (hasRestrictedPlaylists) {
          setShowOptionalModal(true);
          return;
        }
        submitPlaylistsToAdd({
          optional: true
        });
      }
    }), showOptionalModal && /*#__PURE__*/_jsx(PlaylistLinkPermissionModal, {
      onClose: function onClose() {
        setShowOptionalModal(false);
      },
      onSubmit: submitPlaylistsToAdd,
      playlistNames: (restrictedPlaylists === null || restrictedPlaylists === void 0 ? void 0 : restrictedPlaylists.map(function (playlist) {
        return playlist.name;
      })) || []
    })]
  });
}
export default AddPlaylistManager;